export const DEFAULT_SEO = {
  title: 'VurgunBet — Online Casino ve Spor Bahisleri',
  titleEn: 'VurgunBet — Online Casino & Sports Betting',
  description: 'VurgunBet ile spor bahisleri, casino, canlı casino ve daha fazlası.',
  descriptionEn: 'Sports betting, casino, live casino and more at VurgunBet.',
  siteName: 'VurgunBet',
};

export function absoluteAssetUrl(path) {
  if (!path) return '';
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  return `${window.location.origin}${path.startsWith('/') ? path : `/${path}`}`;
}

function isBrokenTitle(value) {
  const t = String(value || '').trim();
  if (!t) return true;
  // Browser fallback / accidental URL titles
  if (/^https?:\/\//i.test(t)) return true;
  if (/^www\./i.test(t)) return true;
  if (/^vurgunbet[\w.-]*$/i.test(t) && !/VurgunBet/i.test(t)) return true;
  return false;
}

export function resolveSeoTitle(title, { locale } = {}) {
  if (!isBrokenTitle(title)) return String(title).trim();
  return locale === 'en' ? DEFAULT_SEO.titleEn : DEFAULT_SEO.title;
}

export function resolveSeoDescription(description, { locale } = {}) {
  const d = String(description || '').trim();
  if (d) return d;
  return locale === 'en' ? DEFAULT_SEO.descriptionEn : DEFAULT_SEO.description;
}

function setMeta(nameOrProp, content, isProperty = false) {
  if (content == null || content === '') return;
  const attr = isProperty ? 'property' : 'name';
  const selector = `meta[${attr}="${nameOrProp}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, nameOrProp);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href, { absolute = true } = {}) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = absolute ? absoluteAssetUrl(href) : href;
}

export function applySeo({ title, description, ogImage, favicon, url, locale } = {}) {
  const safeTitle = resolveSeoTitle(title, { locale });
  const safeDescription = resolveSeoDescription(description, { locale });
  const pageUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

  document.title = safeTitle;

  setMeta('description', safeDescription);
  setMeta('robots', 'index, follow, max-image-preview:large');
  setMeta('og:site_name', DEFAULT_SEO.siteName, true);
  setMeta('og:title', safeTitle, true);
  setMeta('og:description', safeDescription, true);
  setMeta('og:type', 'website', true);
  if (pageUrl) setMeta('og:url', pageUrl, true);
  setMeta('og:locale', locale === 'en' ? 'en_US' : 'tr_TR', true);
  if (ogImage) setMeta('og:image', absoluteAssetUrl(ogImage), true);

  setMeta('twitter:card', ogImage ? 'summary_large_image' : 'summary');
  setMeta('twitter:title', safeTitle);
  setMeta('twitter:description', safeDescription);
  if (ogImage) setMeta('twitter:image', absoluteAssetUrl(ogImage));

  if (favicon) setLink('icon', favicon);
  if (pageUrl) {
    const canonical = pageUrl.split('#')[0];
    setLink('canonical', canonical, { absolute: false });
  }

  return safeTitle;
}

export function seoForLocale(seo, locale) {
  const useEn = locale === 'en';
  const title = (useEn ? seo?.titleEn || seo?.title : seo?.title) || '';
  const description = (useEn ? seo?.descriptionEn || seo?.description : seo?.description) || '';
  return {
    title: resolveSeoTitle(title, { locale }),
    description: resolveSeoDescription(description, { locale }),
    ogImage: seo?.ogImage || '',
    favicon: seo?.favicon || '',
  };
}

/** Restore a stable brand title (e.g. after leaving a game page). */
export function restoreDefaultDocumentTitle(locale) {
  document.title = locale === 'en' ? DEFAULT_SEO.titleEn : DEFAULT_SEO.title;
}
